import React, { useEffect, useState } from "react"
import { connect, useSelector } from "react-redux";
import SvgNotification from "../../iconComponents/IconNotificationBell";
import IconX from "../../iconComponents/IconX";
import { getNotifications } from "../../../actions/core";
import Notification from "./Notification";

export function NotificationBar(props) {

    // when component mounts, ensure global state has people
    useEffect(() => {
        props.getNotifications(); 
    }, []);

    const size = props.notifOpen ? "open" : "closed"
    const [barWillClose, setBarWillClose] = useState(false);
    const notifications = useSelector( (state) => state.core.notifications );
    const unreadCount = notifications.length > 0 ? notifications.filter(notification => !notification.read).length : 0;
    const testNotifications = [
        {
            notification_id: "1", 
            code: 5, // ?
            notification_date: "2021-07-09T02:03:36.444Z", //
            description: "Contract invitation from Company XYZ Should be extra long", //
            action_word: "Respond", //
            link: "/contract/view/a3712f8d-f3b9-40da-8c14-0f04b104f3ad", //
            is_time_sensitive: false, //
            project_name: "Hospital Development", //
            contract_name: "Paving", //
            contract_number: "245234", //
        },
        {
            notification_id: "2", //
            notice: "Invoice Review Required", 
            code: 8,
            notification_date: "2021-07-09T21:19:55.309Z",
            description: "Invoice from Big Corp Inc",
            action_word: "Review",
            link: "/invoice/view/11eb25ab-cd53-4994-8f80-bbf9f5369499",
            is_time_sensitive: true,
            project_name: "Condo Development",
            contract_name: "Paving",
            contract_number: "245234",
            invoice_number: "245636",
            hover: true
        },
        {
            notification_id: "3", //
            notice: "Invoice Review Required", 
            code: 8,
            notification_date: "2021-07-09T21:19:55.309Z",
            description: "Invoice from Big Corp Inc",
            action_word: "Review",
            link: "/invoice/view/11eb25ab-cd53-4994-8f80-bbf9f5369499",
            is_time_sensitive: true,
            project_name: "The Well",
            contract_name: "Section 7 Concrete Pour",
            contract_number: "245234",
            invoice_number: "245636",
        },
        {
            code: 0,
            content_type: "Company",
            notice: "Company Invitation Request",
            notification_date: "2021-07-12T18:44:37.952Z",
            notification_id: "bcdaa3d9-c8fc-4614-b77d-11c8d8813262",
            to_user_id: 3,
        },
        {
            code: 0,
            content_type: "Company",
            notice: "Company Invitation Request",
            notification_date: "2021-07-12T17:09:01.192Z",
            notification_id: "1d5cc73d-546e-4f98-b4e8-a0df58ea52bc",
            to_user_id: 3
        },
        {
            code: 7,
            content_type: "Invoice",
            from_user_id: 1,
            invoice_id: "08d3aacc-57d8-4c54-982f-e4cbb31b1d85",
            notice: "Invoice Reviewer Required",
            notification_date: "2021-07-09T20:34:35.057Z",
            notification_id: "e2cf9ac0-30c2-4d7d-9005-bc7ed5ba4b91",
            to_user_id: 3
        }
    ]

    return (
            <div className={`notification-container ${size}`}>
                <div className="flex-row space-btwn" onMouseEnter={() => setBarWillClose(true)} onMouseLeave={() => setBarWillClose(false)}>
                    <div>
                        <SvgNotification pathClass="g3-fill" className="sp-icon" height="22px"/>
                        <span className="sp-text">Notifications&nbsp;&nbsp;</span>
                        {unreadCount > 0 && <span className="alert-count content2 p w-text light">{unreadCount}</span>}
                    </div>
                    <IconX className="close" height="14px" pathClass={barWillClose ? "g5-fill" : "g7-fill"} />
                </div>
                <hr />
                <div className="notification content1 light g5-text">
                {notifications.length > 0 ? notifications.map((notification, index) => { 
                    return ( 
                        <Notification 
                            key={notification.notification_id} 
                            notification={notification} 
                            toNotification={props.toNotification}   
                        />
                    )   
                }) :  <div>No new notifications</div>} 
                </div>
            </div>

        
    )
}

const mapStateToProps = (state) => ({
    //auth: state.auth,
    //people: state.people.people
})

export default connect(mapStateToProps, {getNotifications})(NotificationBar);